import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Package, FileText, MessageSquare, Menu } from "lucide-react";
import { useQuote } from "../context/QuoteContext";

const openChat = () => {
    document.querySelector('[data-testid="chat-trigger"]')?.click();
};

/* Bottom navigation stile app — visibile solo su mobile (< 768px).
   Glassmorphism con backdrop-blur + shadow morbida verso l'alto. */
export const BottomNav = () => {
    const { items } = useQuote();
    const location = useLocation();

    const badge = items.length > 0 ? items.length : null;

    return (
        <nav
            data-testid="bottom-nav"
            className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/90 backdrop-blur-xl border-t border-gray-100 shadow-[0_-4px_20px_rgba(0,0,0,0.04)]"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            aria-label="Navigazione principale"
        >
            <div className="grid grid-cols-5 h-16 px-1">
                <NavItem to="/" icon={Home} label="Home" exact />
                <NavItem to="/catalogo" icon={Package} label="Catalogo" />
                <NavItem to="/preventivo" icon={FileText} label="Preventivo" badge={badge} />
                <button
                    data-testid="bottom-nav-chat"
                    onClick={openChat}
                    className="relative flex flex-col items-center justify-center gap-1 group text-gray-400 hover:text-nsp-green active:text-nsp-green transition-colors"
                    aria-label="Chat AI"
                >
                    <div className="flex items-center justify-center transition-transform group-hover:-translate-y-0.5">
                        <div className="p-1.5 rounded-xl">
                            <MessageSquare className="w-5 h-5 text-gray-400 group-hover:text-gray-600 transition-colors" strokeWidth={2.2} />
                        </div>
                    </div>
                    <span className="text-xs font-semibold text-gray-400 group-hover:text-gray-600 transition-colors">Chat</span>
                </button>
                <NavItem
                    to="/menu"
                    icon={Menu}
                    label="Menu"
                    isActiveExtra={["/corsi", "/notifiche", "/contatti"].includes(location.pathname)}
                />
            </div>
        </nav>
    );
};

const NavItem = ({ to, icon: Icon, label, badge, exact, isActiveExtra }) => (
    <NavLink
        to={to}
        end={exact}
        data-testid={`bottom-nav-${label.toLowerCase()}`}
        className="relative flex flex-col items-center justify-center gap-1 group"
    >
        {({ isActive }) => {
            const active = isActive || isActiveExtra;
            return (
                <>
                    <div
                        className={`relative flex items-center justify-center transition-transform ${active ? "-translate-y-0.5" : "group-hover:-translate-y-0.5"}`}
                    >
                        <div
                            className={`p-1.5 rounded-xl transition-colors ${active ? "bg-nsp-green-50" : ""}`}
                        >
                            <Icon
                                className={`w-5 h-5 transition-colors ${active ? "text-nsp-green" : "text-gray-400 group-hover:text-gray-600"}`}
                                strokeWidth={active ? 2.5 : 2.2}
                            />
                        </div>
                        {badge != null && (
                            <span className="absolute -top-2.5 -right-3 min-w-[22px] h-[22px] px-1.5 bg-nsp-yellow text-nsp-green text-xs font-extrabold rounded-full flex items-center justify-center shadow-md ring-2 ring-white">
                                {badge}
                            </span>
                        )}
                    </div>
                    <span
                        className={`text-xs font-semibold transition-colors ${active ? "text-nsp-green" : "text-gray-400 group-hover:text-gray-600"}`}
                    >
                        {label}
                    </span>
                </>
            );
        }}
    </NavLink>
);

export default BottomNav;
